import React from 'react'
import * as components from './components'

const Alerts: React.FC = (props) => {
  return (
    <>
      {Object.values(components).map((Alert, index) => (
        <Alert key={index} />
      ))}
    </>
  )
}

export default Alerts
